export const userInputs = [
    {
      id: "username",
      label: "Username",
      type: "text",
      placeholder: "John Doe",
    },
    {
      id: "email",
      label: "Email",
      type: "mail",
      placeholder: "john_doe@gmail.com",
    },
    {
      id: "phonenumber",
      label: "Phone",
      type: "text",
      placeholder: "+1 234 567 89",
    },
    {
      id: "password",
      label: "Password",
      type: "password",
    },
    {
      id: "address",
      label: "Address",
      type: "text",
      placeholder: "Elton St. 216 NewYork",
    },
    // {
    //   id: "country",
    //   label: "Country",
    //   type: "text",
    //   placeholder: "USA",
    // },
  ];
  
  export const roomsInputs = [
    {
      id: "name",
      label: "Name",
      type: "text",
      placeholder: "Enter the room name",
    },
    {
      id: "price",
      label: "Price",
      type: "number",
      placeholder: "enter the price",
    }
    // {
    //   id: 2,
    //   label: "Description",
    //   type: "text",
    //   placeholder: "Description",
    // },
    // {
    //   id: 3,
    //   label: "Category",
    //   type: "text",
    //   placeholder: "Computers",
    // },
    
    // {
    //   id: "status",
    //   label: "Status",
    //   type: "boolean",
    //   value: "",
      
    // },
  ];
  